import React from 'react';
import { CredentialsState } from './credentialsState/CredentialsState';
import { CredentialsControlPanel } from './components/CredentialsControlPanel/CredentialsControlPanel';
import { Credentials } from './components/Credentials/Credentials';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

export const CredentialsPage: React.FC = () => {
	return (
		<CredentialsState>
			<div className={style.container} data-test="CredentialsPage">
				<CredentialsControlPanel />
				<Credentials />
				<ModalWindows />
			</div>
		</CredentialsState>
	);
};
